import { render } from "./CarrierChanges.vue?vue&type=template&id=c4f7ceaa&scoped=true"
import script from "./CarrierChanges.vue?vue&type=script&lang=js"
export * from "./CarrierChanges.vue?vue&type=script&lang=js"

import "./CarrierChanges.vue?vue&type=style&index=0&id=c4f7ceaa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4f7ceaa"]])

export default __exports__